import React, { useCallback, useEffect, useState } from 'react';
// Core
import { NavLink } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { closeLoginModal } from 'src/store/layout/slice';

import { useHistory } from 'react-router';
import { APP_ROUTES } from 'src/routing/AppRoutes';

import { LinearProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { maxContainerWidth } from 'src/materialConfig/theme';
import { UnAuthorizedMenuContainer } from './menu/UnAuthorizedMenu/UnAuthorizedMenuContainer';
import { AuthorizedMenu } from './menu/AuthorizedMenu/AuthorizedMenu';
import { LoginModal } from '../../../features/auth/login/LoginModal';
import { useDialogVisibility } from 'src/utils/hooks/useDialogVisibility';
import { ForgotPasswordModalContainer } from '../../../features/auth/password/forgot/ForgotPasswordModalContainer';
import { useDeviceSizeType } from '../../../utils/hooks/useDeviceType';
import { Helmet } from 'react-helmet';

// Assets
import appLogo from 'src/assets/images/app-logo.png';
import appIcon from 'src/assets/images/app-icon.png';
import { ExpertFields } from 'src/features/auth/login/ExpertFields';
import { useFetch } from 'src/utils/hooks/useFetch';
import { IRegisterAsExpert1Model } from 'src/api/base/Auth/types';
import { AuthApi } from 'src/api/base/Auth';
import { setUser } from 'src/store/auth/slice';
import { setAuthTokenInSystem } from 'src/store/auth/asyncThunk';

const url = window.location.pathname;

const desktopMenuHeight = (url !== APP_ROUTES.SURVEY_FORM) ? '100px' : 0;
const mobileMenuHeight = (url !== APP_ROUTES.SURVEY_FORM) ? '80px' : 0;

export const useStyles = makeStyles((theme) => ({
  root: {
    position: 'fixed',
    top: 0,
    zIndex: 100,
    boxShadow: '0px 4px 20px rgba(108, 108, 108, 0.15)',
    height: desktopMenuHeight,
    width: '100%',
    background: 'white',
    [theme.breakpoints.down('lg')]: {
      height: mobileMenuHeight,
    },
  },
  main: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: desktopMenuHeight,
    minHeight: `calc(100vh - ${desktopMenuHeight})`,
    background: 'white',
    [theme.breakpoints.down('lg')]: {
      marginTop: mobileMenuHeight,
      minHeight: `calc(100vh - ${mobileMenuHeight})`,
    },
	overflow: 'hidden'
  },
  container: {
    height: '100%',
    margin: '0 auto',
    maxWidth: maxContainerWidth,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'relative',

    [theme.breakpoints.down('lg')]: {
      padding: '0 20px',
    },
    '& ul:last-child li':{
      borderBottom: 'none',
	  paddingBottom: 'unset'
    }
  },
  appLogo: {
    [theme.breakpoints.down('lg')]: {
      maxWidth: '130px',
    },
  },
}));

export const HeaderLayout: React.FC = (props) => {
  const { children } = props;
  const classes = useStyles();
  const history = useHistory();
  const { mainLoading } = useSelector((state: RootState) => state.layout);
  const { user } = useSelector((state: RootState) => state.auth);

  // Start handling modals visibility
  const dispatch = useDispatch();
  const { modals } = useSelector((state: RootState) => state.layout);

  const handleLoginModalRegisterClick = useCallback(() => {
    dispatch(closeLoginModal());
    history.push(APP_ROUTES.REG_AS_JOURNALIST);
  }, [dispatch, history]);

  const handleCloseLoginModal = useCallback(() => {
    dispatch(closeLoginModal());
  }, [dispatch]);
  // End handling modals visibility

  const {
    isOpened: openedForgotPswModal,
    handleOpen: openForgotPsw,
    handleClose: closeForgotPswModal,
  } = useDialogVisibility();

  const { isDesktop } = useDeviceSizeType();

  const [expertData, setExpertData] = useState(false)

  useEffect(() => {
    if(!user?.profile?.company_name && user?.id && user.role !== 1 && user.status !== 0){
      setExpertData(true)
    }else{
      setExpertData(false)
    }
  }, [user])

  const [{ response }, doFetch] = useFetch<
    any,
    IRegisterAsExpert1Model
  >(AuthApi.loginExpertPart);

  useEffect(() => {
    if (response) {
      dispatch(setUser(response?.data?.user));
      setAuthTokenInSystem(response?.data?.access_token);
      history.push(APP_ROUTES.REG_AS_EXPERT2);
    }
  }, [response, history, dispatch]);

  const handleExpertSubmit = (data:any) =>{
    data.expert_id = user?.id;
    doFetch(data)
  }
  

  const header = 
	url !== APP_ROUTES.SURVEY_FORM ? (
    <>
      <header className={classes.root}>
        <div className={classes.container}>
          <NavLink to={APP_ROUTES.MAIN}>
            <img
              src={isDesktop ? appLogo : appIcon}
              className={classes.appLogo}
              alt="Logo"
            />
          </NavLink>
          {user ? <AuthorizedMenu /> : <UnAuthorizedMenuContainer />}
        </div>
        {mainLoading.status && <LinearProgress color="primary" />}
      </header>
      <main className={classes.main}>{children}</main>

      <LoginModal
        open={modals.isLoginModalOpened}
        onClose={handleCloseLoginModal}
        onRegisterClick={handleLoginModalRegisterClick}
        onForgotPassword={openForgotPsw}
      />

    <ExpertFields
      open = {expertData}
      onSubmit={handleExpertSubmit}
    />

      {openedForgotPswModal && (
        <ForgotPasswordModalContainer onClose={closeForgotPswModal} open />
      )}

      <Helmet>
        <script src="https://www.googletagmanager.com/gtag/js?id=G-5KS7R9T896" /> 
        <script> 
          {
            `
              window.dataLayer = window.dataLayer || []; 
              function gtag(){ dataLayer.push(arguments)} 
              gtag('js', new Date()); 
              gtag('config', 'G-5KS7R9T896'); 
            `
          } 
        </script>
        <script>
          {`
            (function(w, d, s, l, i) {
              w[l] = w[l] || [];
              w[l].push({
                'gtm.start': new Date().getTime(),
                event: 'gtm.js'
              });
              var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s),
                dl = l != 'dataLayer' ? '&l=' + l : '';
              j.async = true;
              j.src =
                'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
              f.parentNode.insertBefore(j, f);
            })(window, document, 'script', 'dataLayer', 'GTM-TXJHR5N');   
          `}    
        </script>
		<script type="text/javascript" src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js" async />
		<script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7203316589261507" crossOrigin="anonymous" />
      </Helmet>
    </>
	) : ( 
		<>
			<main className={classes.main}>{children}</main>
		</> 
	);
	
	return header;
};
